module.exports = __webpack_public_path__ + "static/media/icon_gl.0b775aea.png";